var exports = {
  "q": "resolvedCountLabel__Op-E71",
};

module.exports = exports;
